import { jsx as _jsx } from "react/jsx-runtime";
import { AppTypography } from './Typography.styled';
export const Typography = (props) => {
    const { color = 'textPrimary' } = props;
    return _jsx(AppTypography, Object.assign({}, props, { color: color }));
};
export default Typography;
